import React from "react";
import getConfig from "next/config";

import Heading from "@components/Heading";
import Link from "next/link";

const {
  publicRuntimeConfig: {
    content: {
      phone: contactPhone,
      phoneSecondary: contactPhoneSecondary,
      fax: contactFax,
      // corporatePhone,
    },
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const ContactsSidebar = ({ cmsBlocks }) => (
  <>
    <div className="mb-12">
      <Heading as="h3" display="h1" title="Call center" classesProp="mb-3" />

      <p className="leading-none">
        <a className="block text-2xl text-black" href={`tel:${contactPhone}`}>
          {contactPhone}
        </a>
        <span className="block mt-1 leading-tight text-gray-text">
          Disponibil in toate retelele (tarif normal)
        </span>
      </p>

      {!isBricoStore && (
        <p className="m-0 mt-3 leading-none">
          <a
            className="block text-2xl text-black"
            href={`tel:${contactPhoneSecondary}`}
          >
            {contactPhoneSecondary}
          </a>
          <span className="block mt-1 leading-tight text-gray-text">
            Apelabil din orice retea, din tara si din strainatate (tarif normal)
          </span>
        </p>
      )}
    </div>

    <div className="mb-12">
      <Heading
        as="h3"
        display="h1"
        title="Program call center"
        classesProp="mb-3"
      />

      <div
        dangerouslySetInnerHTML={{
          __html: cmsBlocks["contacts-serviciul-relatii-clienti"],
        }}
      />
    </div>

    <div className="mb-12">
      <Heading as="h3" display="h1" title="Sediu central" classesProp="mb-3" />

      <p className="my-3">
        Soseaua Bucuresti-Nord, Nr. 10, Corp O1, Voluntari, Judetul Ilfov
      </p>

      {!isBricoStore && (
        <p className="m-0 mt-1">
          <b className="font-bold">Fax:</b> <span>{contactFax}</span>
        </p>
      )}
    </div>

    <div>
      <Heading
        as="h3"
        display="h1"
        title="Vanzari corporate"
        classesProp="mb-3"
      />

      <p className="m-0 mt-3">
        {/* <b className="font-bold">Telefon:</b> <span>{corporatePhone}</span> */}
        <div>
          <Link href="/vanzari-corporate/pag/">
            <a className="underline">Contact</a>
          </Link>
        </div>
      </p>
    </div>
  </>
);

export default ContactsSidebar;
